"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { usePathname } from "next/navigation";
import { getCurrentAreaInClient } from "@/lib/utils.client";
import { useORPC } from "@/providers/orpc-provider";
import { textBannerVisibleAtom } from "@/store/textBannerAtom";
import { TextBanner } from "./text-banner";
export function TextBannerWrapper() {
  const $ = _c(8);
  const pathname = usePathname();
  const area = getCurrentAreaInClient();
  const orpc = useORPC();
  const isHomePage = pathname.replace(/^\/[a-zA-Z-]+/, "") === "" || pathname.replace(/^\/[a-zA-Z-]+/, "") === "/";
  const isBannerVisible = useAtomValue(textBannerVisibleAtom);
  const t0 = orpc.cms.content.public_findLiveWithPagination.queryOptions({
    input: {
      group: "header-batch-query",
      area: area?.toUpperCase(),
      includeChildren: true,
      platform: "web"
    }
  });
  let t1;
  if ($[0] !== t0) {
    t1 = {
      ...t0,
      staleTime: 300
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: headerBatchResponse
  } = useQuery(t1);
  let t2;
  if ($[2] !== headerBatchResponse) {
    t2 = (headerBatchResponse as any)?.items || [];
    $[2] = headerBatchResponse;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const headerBatch = t2;
  let t3;
  if ($[4] !== headerBatch) {
    t3 = headerBatch.find(_temp);
    $[4] = headerBatch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const bannerResponse = t3;
  const banners = bannerResponse?.children || [];
  if (!isHomePage || !isBannerVisible || banners.length === 0) {
    return null;
  }
  let t4;
  if ($[6] !== bannerResponse) {
    t4 = <TextBanner bannerData={bannerResponse} />;
    $[6] = bannerResponse;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(item) {
  return item.alias === "text-banner-config";
}